/**
 * /app/structure, Path A: a firm maps an existing client's trust structure
 * using the document-driven builder (route shell). Nothing here checks that the
 * client has been identity-verified first (RULING, orchestrator, 22 Sep,
 * reversible: mapping is not blocked on FICA); the screen says what is
 * outstanding instead, see ./structure-advisory.ts.
 *
 * Reached from the Client Book / client-detail "Map structure" action, after a
 * MANAGE act-as token has been minted + stored for the client. The body lives in
 * ./structure-screen.tsx and is lazy-loaded (the StructureBuilderScreen chunk is
 * heavy — kept off the entry bundle, same shell+screen split as ./setup.tsx).
 *
 * Hand-added to routeTree.gen.ts mirroring the sibling /app/setup single-route
 * registration (do NOT regen the routeTree via the plugin — it rewrites the
 * hand-edited custom URLs; see ./setup.tsx).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/structure')({
  // `mode=new` → a BRAND-NEW client (A2): run the FULL builder incl. the
  // identity/FICA card (the firm uploads the client's ID). Default (absent) →
  // an existing client (A1): start at Structure and skip the identity card.
  // The skip does not check the client's FICA.
  validateSearch: (s: Record<string, unknown>): { mode?: 'new' } =>
    s['mode'] === 'new' ? { mode: 'new' } : {},
  component: lazyRouteComponent(() => import('./structure-screen'), 'StructureScreen'),
});
